core.factory('loadingInterceptor', [ '$q', '$rootScope',
    function ($q, $rootScope) {
        var requestCount = 0;

        return {
            request: function(config) {
                if (config && config.method && config.method == 'POST') {
                    requestCount++;
                    $rootScope.$broadcast(Event.LOADING, true);
                }
                return config;
            },
            response: function (response) {
                if (response && response.config && response.config.method && response.config.method == 'POST') {
                    requestCount--;
                    if (requestCount == 0) {
                        $rootScope.$broadcast(Event.LOADING, false);
                    }
                }
                return response;
            },
            responseError: function(rejection) {  // rejection is HttpResponseVO
                if (rejection && rejection.config && rejection.config.method && rejection.config.method == 'POST') {
                    requestCount--;
                    if (requestCount == 0) {
                        $rootScope.$broadcast(Event.LOADING, false);
                    }
                }
                return $q.reject(rejection);
            }
        };
    }
]);
